import apiClient from '../apiClient';
import { GET_USER_ROLE_BY_USER_ID_URL } from '../apiUrl';

const getUserRoleByUserIdApi = id => {
  return apiClient.get(GET_USER_ROLE_BY_USER_ID_URL(id));
};

export default getUserRoleByUserIdApi;
